import { gql } from 'graphql-request';

export const GET_MY_ORGANIZATIONS_PARTICIPATIONS = gql`
  query CoreOrganizationParticipations {
    coreOrganizationParticipations {
      my {
        id
        application {
          widgets {
            id
            header
            fields {
              id
              viewName
              viewIndex
              access
              path
              api
            }
          }
        }
      }
    }
  }
`;
